import { OrderItemDetails } from '../../../app/services/api/orderManagementClient';
import { OrderStatus } from '../../../enums/OrderStatus';

export const getRelevantOrderQuantity = (
  status: string | null | undefined,
  item: Pick<OrderItemDetails, 'confirmedQuantity' | 'shippedQuantity'>,
  orderedQuantity: number,
): number => {
  if (status === OrderStatus.OrderShipped) {
    return item.shippedQuantity;
  }

  if (status === OrderStatus.Amended) {
    return item.confirmedQuantity;
  }

  return orderedQuantity;
};
